module.exports = __webpack_public_path__ + "img/mrimg2.a8045fd4.jpg";